import styled from '@emotion/styled'
import {
  Box,
  Theme,
  Typography,
  Input,
  ListItemText,
  MenuItem,
  Select,
} from '@yuno/design-system-web'

export const AlternativeTextTypo = styled(Typography)<{ theme?: Theme }>`
  color: ${({ theme }) => theme.palette.neutral.black};
  ${({ theme }) => theme.typography.small.regular};
  position: absolute;
  background: white;
  left: 16px;
  padding-top: 10px;
  width: 80%;
  z-index: 1;
  right: 0;
  margin: 1px;
`

export const StyledSelect = styled(Select)<{ theme?: Theme }>`
  background: ${({ theme }) => theme.palette.common.white};;
`

export const AlternativeTextTypoSelect = styled(Typography)<{ theme?: Theme }>`
  color: ${({ theme }) => theme.palette.neutral.black};
  ${({ theme }) => theme.typography.small.regular};
  position: absolute;
  background: ${({ theme }) => theme.palette.common.white};;
  left: 16px;
  width: 80%;
  z-index: 1;
  right: 0;
  margin: 1px;
`

export const CustomBoxSearch = styled(Box)<{
  theme?: Theme
  isTesting: string
}>`
  border: 1px solid ${({ theme }) => theme.palette.grey[2]};
  width: 256px;
  border-radius: 4px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.neutral.white};
  margin-right: 20px;
  height: 42px;
  position: absolute;
  top: ${({ isTesting }) => (isTesting === 'OFF' ? '100px' : '130px')};
  right: 20px;
`

export const ContainerSearch = styled(Box)<{ theme?: Theme }>`
  width: 100%;
  justify-content: space-between;
  display: flex;
  margin-bottom: 10px;
`

export const CustomInputSearch = styled(Input)(
  ({ theme }: { theme?: Theme }) => ({
    '& .MuiInputBase-input.MuiOutlinedInput-input': {
      ...theme.typography.small.regular,
      color: theme.palette.neutral.black,
      border: 'none',
      width: '188px',
      height: '20px',
    },
  }),
)

export const CustomInputCountriesSearch = styled(Input)(
  ({ theme }: { theme?: Theme }) => ({
    '& .MuiInputBase-input.MuiOutlinedInput-input': {
      ...theme.typography.small.regular,
      color: theme.palette.neutral.black,
      border: 'none',
      width: '188px',
      height: '20px',
    },
  }),
)

export const CustomListItemText = styled(ListItemText)(() => ({
  '& span': {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
}))

export const PageTitle = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => theme.typography['3xl'].bold};
  color: ${({ theme }) => theme.palette.neutral.black};
  margin-bottom: 12px;
`
